export enum TradeType {
  "accept_application" = "accept_application",
  "add_application" = "add_application",
  "add_employee" = "add_employee",
  "add_jobOffer" = "add_jobOffer",
  "add_proposal" = "add_proposal",
}
